import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { PGSBlock } from 'stdjs/pgs';
import { setupSelect2 } from 'stdjs/select2-config';
import { setupMultiSelect } from '../stdjs/multi-select';
import { setupSubsetField } from '../stdjs/subset-field';
import { setupFilePond } from 'js/stdjs/filepond-setup';

var projectPGSBlock;

$(document).ready(function(){

    projectPGSBlock = buildPGSBlock();

    var assessorSubset = setupSubsetField({
        selector: $("#ASSESSOR_BLOCK"),
        subsetTogglePostKey: "assessorToggle",
        multiSelectPostKey: "assessors"
    });

    var calcSubset = setupSubsetField({
        selector: $("#CALC_STATUS_BLOCK"),
        subsetTogglePostKey: "calculationStatusToggle",
        multiSelectPostKey: "calculationStatus"
    });

    var taskSubset = setupSubsetField({
        selector: $("#TASK_TYPE_BLOCK"),
        subsetTogglePostKey: "taskTypeToggle",
        multiSelectPostKey: "taskType"
    });

    var plotErrorSubset = setupSubsetField({
        selector: $("#PLOT_ERROR_BLOCK"),
        subsetTogglePostKey: "plotErrorToggle",
        multiSelectPostKey: "plotError"
    });


    document.addEventListener("basecoat:popover:open", (e) => {

        var popover = $(e.detail.source);
        var popoverContent = popover.find(".popover-content");

        if (popover.hasClass("ignore-overflow-fix")){
            console.log("ignore");
            return;
        }

        var popoverLeft = popover.position().left - 100;
        var popoverTop  = popover.position().top + 100;

        popoverContent.css({top: popoverTop, left: popoverLeft});
        popoverContent.attr("data-id", popover.closest(".pgs-item").attr("data-id"));
        popoverContent.attr("data-type", popover.closest(".pgs-item").attr("data-type"));

        popover.closest(".pgs-list").removeClass("overflow-y-auto");
        popover.closest(".pgs-list").addClass("overflow-hidden");   

        $("body").append(popoverContent);
    });

    document.addEventListener("basecoat:popover:close", (e) => {

        var popover = $(e.detail.source);
        if (popover.hasClass("ignore-overflow-fix")){
            console.log("ignore");
            return;
        }
        
        var popoverContent = $("#" + $(popover).attr("data-type") + "-" + $(popover).attr("data-id") + "-content");

        popoverContent.css({left: "", top: "100%"});
        popover.append(popoverContent);

        if ($(".popover-content[aria-hidden='false']").length < 2){
            popover.closest(".pgs-list").addClass("overflow-y-auto");
            popover.closest(".pgs-list").removeClass("overflow-hidden");
        }
    });

    $("#subsetDistribute").click(function(){
        
        assessorSubset.setMeSelected();

        calcSubset.setToggleValue("SELECTED");
        calcSubset.setMultiValue("400");
        taskSubset.setToggleValue("ANY");
        plotErrorSubset.setToggleValue("ANY");

    });

    $("#subsetToDo").click(function(){
        
        assessorSubset.setMeSelected();
        calcSubset.setToggleValue("ANY");
        taskSubset.setToggleValue("HAS");
        plotErrorSubset.setToggleValue("ANY");

    });

    $("#subsetApply").click(function(){

        var subsetData = assessorSubset.getPostData()
        subsetData += calcSubset.getPostData();
        subsetData += taskSubset.getPostData();
        subsetData += plotErrorSubset.getPostData();
        subsetData += "&applyClick=true";
        
        var successCallback = function(data){
            $("#PGS_CONTAINER").html(data.html);
            projectPGSBlock.triggerPreSelect();
        }
        
        standardAjaxPost(getPlotsViaSubsetUrl, subsetData, successCallback);
    });

    $("#subsetReset").click(function(){
        assessorSubset.resetSubsetField();
        calcSubset.resetSubsetField();
        taskSubset.resetSubsetField();
        plotErrorSubset.resetSubsetField();
    });
    
    setupFilePond(
        $( '#PLOT_MANUAL_UPLOAD_DIALOG_FILEPOND' ),
        false,
        $( "#PLOT15_UPLD" ),
        plotSaveManualUploadUploadUrl,
        null, 
        {}
    )
    
});

function buildPGSBlock(){

    var projectPGSBlock = PGSBlock({
        selector: "#plots-pgs",
        plotsUrl: getPlotsUrl,
        plotUrl: getPlotUrl,
        updatePgsSessionDetailsUrl: updatePgsSessionDetailsUrl,
        preSelectSingle: true,
        onPlotLoaded: function(){

            var filterSubset = setupSubsetField({
                selector: $("#TASKFILTER_BLOCK", ".plot-detail"),
                onChangeListener: function(event){
                    
                    var target = $(event.target);
                    var value = target.val();

                    if (value === "ALL"){
                        $("#OustandingTasksTable tbody tr").removeClass("hidden");
                        $("#TASK_HEADER").text("All Tasks");
                    }

                    if (value === "ACTIVE"){
                        $("#OustandingTasksTable tbody tr[data-complete='true']").addClass("hidden");
                        $("#TASK_HEADER").text("Outstanding Tasks");
                    }
                }
            });
        }
    });

    return projectPGSBlock;
}

export function updatePlotDetail( data ){
    projectPGSBlock.updatePlotDetail( data );
}